export default [
  {
    description: 'Exportar Arquivo da 1ª Etapa (Matrícula Inicial)',
    path: '/censoescolar/matriculainicial',
    name: 'censo_exportar_etapa1',
    component: () => import('@/views/censoescolar/matriculainicial/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Relatório de Pendências da 1ª Etapa (Matrícula Inicial)',
    path: '/censoescolar/matriculainicial',
    name: 'censo_rel_pendencias_etapa1',
    component: () => import('@/views/censoescolar/matriculainicial/RelatorioPendencias.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
]

